import { store } from '@services/store'

export const convertToTextObject = (key: string, value: string) => {
  return {
    key,
    value,
    lang: store.getState().cms.language
  }
}
